// eslint-disable-next-line import/no-unresolved
import { Auth } from 'auth/services/Auth';

import { getIdUiUrl } from '@utils/URLs';

const auth = Auth.getInstance();

// When the user requests a login page send them to the correct one based on dev mode
const LoginRoute = () => {
    // If we are logged in don't redirect to login page
    if (auth.isAuthenticated() as boolean) {
        window.location.replace('/');
        return null;
    }
    // redirect to ID UI to auth there
    const url = getIdUiUrl();
    const paramReturn = `returnTo=${encodeURI(
        `${window.location.origin}${window.location.pathname}${window.location.search}`,
    )}`;
    window.location.replace(`${url}?${paramReturn}`);

    return <div />;
};

export default LoginRoute;
